// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"f2fb7ed9","493":"714a6b80","720":"97548610"}[chunkId] + ".chunk.css";
};